import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import type { PartnerLimitCreateV2, PartnerLimitV2 } from '@shipium-corp/shipium-ts-types';
import type { V2LimitUpdatePayload } from '~/store/services/LimitService/types';
import {
  ALL_PARTNER_LIMITS_QUERY_KEY,
  DOCK_LANE_LIMITS_QUERY_KEY,
  DOCK_LANE_SHIPMENT_COUNTS_QUERY_KEY,
} from '~/hooks/queries/dockLaneQueryKeys';
import { LIMITS_BASE } from './limit-constants';

// Both lane-scoped consumers (per-lane drawer + partner-wide grouped table) and the
// timeline's segment counts need refreshing after a write — non-lane writes only touch
// the partner-wide key. Exported so the branching is unit-tested.
export const invalidationKeysFor = (laneId: string | undefined): string[][] =>
  laneId
    ? [[DOCK_LANE_LIMITS_QUERY_KEY, laneId], [ALL_PARTNER_LIMITS_QUERY_KEY], [DOCK_LANE_SHIPMENT_COUNTS_QUERY_KEY]]
    : [[ALL_PARTNER_LIMITS_QUERY_KEY], [DOCK_LANE_SHIPMENT_COUNTS_QUERY_KEY]];

export const partnerLimitMutations = {
  create: async (payload: PartnerLimitCreateV2) => {
    const { data } = await GatewayAxiosClient.post<PartnerLimitV2>(LIMITS_BASE, payload);
    return { data, invalidateQueryKeys: invalidationKeysFor(payload.laneId) };
  },

  update: async (payload: V2LimitUpdatePayload & { laneId?: string }) => {
    const { data } = await GatewayAxiosClient.put<PartnerLimitV2>(
      `${LIMITS_BASE}/${encodeURIComponent(payload.limitId)}`,
      payload,
    );
    return { data, invalidateQueryKeys: invalidationKeysFor(payload.laneId) };
  },
};
